import { Component, inject, OnInit } from '@angular/core';
import { PageTitleService } from '../../shared/services';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-settings',
  imports: [RouterOutlet],
  templateUrl: './settings.html',
  styleUrl: './settings.css',
})
export class Settings {}
